import { render } from "./EditDescriptionModal.vue?vue&type=template&id=10e846ae&scoped=true"
import script from "./EditDescriptionModal.vue?vue&type=script&lang=js"
export * from "./EditDescriptionModal.vue?vue&type=script&lang=js"

import "./EditDescriptionModal.vue?vue&type=style&index=0&id=10e846ae&lang=scss&scoped=true"
import "./EditDescriptionModal.vue?vue&type=style&index=1&id=10e846ae&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e846ae"]])

export default __exports__